import { isDeleted } from '../../services/User';
import Link from '../Link';
import PrepareUser from '../PrepareUser';
import UserLabel from '../UserLabel';

function UserLink(props) {
    const { user, eventTracking } = props;
    if (user.link && !isDeleted(user)) {
        return (
            <Link href={user.link} eventTracking={eventTracking}>
                <UserLabel {...props} />
            </Link>
        );
    }
    return <UserLabel {...props} />;
}

export default PrepareUser(UserLink); // eslint-disable-line new-cap
